export default __webpack_public_path__ + "static/media/tent.11dc7fa1.jpg";